import { useAuthStore } from '../store/authStore';

export const useAuth = () => {
  const store = useAuthStore();
  return {
    user: store.user,
    token: store.token,
    organizations: store.organizations,
    activeOrganization: store.activeOrganization,
    isLoading: store.isLoading,
    isInitialized: store.isInitialized,
    rememberMe: store.rememberMe,
    login: store.login,
    register: store.register,
    logout: store.logout,
    switchOrganization: store.switchOrganization,
    acceptInvite: store.acceptInvite,
    fetchMe: store.fetchMe,
    getRole: store.getRole,
    can: store.can,
  };
};